import { BarChart3, Grid3x3, FileText, ArrowRight } from "lucide-react";

const features = [
  {
    icon: BarChart3,
    title: "Account Analytics",
    desc: "Track followers, views, likes, and more with daily breakdown charts.",
  },
  {
    icon: FileText,
    title: "Post Analytics",
    desc: "See which posts perform best. Sort by views, likes, or replies.",
  },
  {
    icon: Grid3x3,
    title: "Engagement Heatmap",
    desc: "Discover when your audience is most active with an hourly heatmap.",
  },
];

export function LandingPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="border-b border-border">
        <div className="mx-auto flex h-14 max-w-5xl items-center justify-between px-4">
          <span className="text-lg font-bold tracking-tight">Yarnalytics</span>
          <a
            href="/login"
            className="rounded-lg bg-black px-4 py-2 text-sm font-medium text-white hover:bg-neutral-800 transition-colors"
          >
            Sign in
          </a>
        </div>
      </header>

      {/* Hero */}
      <section className="mx-auto max-w-3xl px-4 pt-20 pb-16 text-center">
        <h1 className="text-4xl font-bold tracking-tight sm:text-5xl">
          Analytics for your
          <br />
          Threads account
        </h1>
        <p className="mt-4 text-lg text-neutral-500 max-w-xl mx-auto">
          Track your growth, understand your audience, and find the best time
          to post. Simple, clean analytics for Threads creators.
        </p>
        <div className="mt-8 flex justify-center gap-3">
          <a
            href="/login"
            className="flex items-center gap-2 rounded-lg bg-black px-6 py-3 text-sm font-medium text-white hover:bg-neutral-800 transition-colors"
          >
            Get Started
            <ArrowRight className="h-4 w-4" />
          </a>
        </div>
        <p className="mt-3 text-xs text-neutral-400">
          Free tier available. No credit card required.
        </p>
      </section>

      {/* Features */}
      <section className="mx-auto max-w-5xl px-4 pb-20">
        <div className="grid gap-6 sm:grid-cols-3">
          {features.map((f) => (
            <div
              key={f.title}
              className="rounded-xl border border-border p-6"
            >
              <f.icon className="h-6 w-6 mb-3" />
              <h3 className="font-semibold">{f.title}</h3>
              <p className="mt-1 text-sm text-neutral-500">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Pricing */}
      <section className="border-t border-border bg-surface py-16">
        <div className="mx-auto max-w-3xl px-4 text-center">
          <h2 className="text-2xl font-bold tracking-tight">Simple pricing</h2>
          <p className="mt-2 text-sm text-neutral-500">
            Start free, upgrade when you need more.
          </p>

          <div className="mt-8 grid gap-4 sm:grid-cols-2 max-w-xl mx-auto">
            {/* Free */}
            <div className="rounded-xl border border-border bg-white p-6 text-left">
              <h3 className="font-semibold">Free</h3>
              <p className="mt-1 text-3xl font-bold">$0</p>
              <ul className="mt-4 space-y-2 text-sm text-neutral-500">
                <li>1 Threads account</li>
                <li>7 days data retention</li>
                <li>Account overview analytics</li>
                <li>Daily trend charts</li>
              </ul>
            </div>

            {/* Pro */}
            <div className="rounded-xl border-2 border-black bg-white p-6 text-left">
              <h3 className="font-semibold">Pro</h3>
              <p className="mt-1 text-3xl font-bold">
                $9.99<span className="text-sm font-normal text-neutral-400">/mo</span>
              </p>
              <ul className="mt-4 space-y-2 text-sm text-neutral-500">
                <li>Up to 5 Threads accounts</li>
                <li>90 days data retention</li>
                <li>Post-level analytics</li>
                <li>Engagement heatmap</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-border">
        <div className="mx-auto flex h-14 max-w-5xl items-center justify-between px-4 text-xs text-neutral-400">
          <span>Yarnalytics</span>
          <span>Analytics for Threads creators</span>
        </div>
      </footer>
    </div>
  );
}
